import axios from 'axios';

export function getPhysicalDamage(model, VIN, referenceId, endDate, report, product, config) {
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
    'x-location-id': localStorage.getItem('locationId')
  };
  const reference = referenceId || '';
  const modelVal = model || 'default';
  const url = `${config.v2aciReports}?model=${modelVal}&VIN=${VIN}&referenceId=${reference}&endDate=${endDate}&report=${report}&product=${product}`;
  return dispatch => dispatch({
    type: 'PHYSICAL_DAMAGE_FETCH',
    payload: axios({ method: 'get', url, headers })
  }).catch((error) => {
    console.log(error);
  });
}

export function clearPhysicalDamage() {
  return {
    type: 'PHYSICAL_DAMAGE_CLEAR',
    payload: ''
  };
}



// WEBPACK FOOTER //
// ./src/actions/getPhysicalDamage.js